import ConcordanceDialog from "@/components/ConcordanceDialog";

// Renders text with inline, tappable Strong's citations (Pillar 1 — Visible Sourcing).
// The study model emits citations like "bara (H1254)" / "agapē (G26)"; we turn every
// (H####)/(G####) into a tappable chip that opens the SOURCED concordance entry.
const CITE = /\(([GH]\d{1,4})\)/g;

export default function InlineStrongs({ text, sessionId, className = "" }) {
  const str = text || "";
  const nodes = [];
  let last = 0;
  let m;
  let k = 0;
  CITE.lastIndex = 0;
  while ((m = CITE.exec(str)) !== null) {
    if (m.index > last) nodes.push(str.slice(last, m.index));
    nodes.push(
      <ConcordanceDialog
        key={`s-${k++}`}
        number={m[1]}
        sessionId={sessionId}
        className="align-baseline mx-0.5 py-0"
        testid={`inline-strongs-${m[1]}-${k}`}
      />
    );
    last = m.index + m[0].length;
  }
  if (last < str.length) nodes.push(str.slice(last));
  return <span className={className}>{nodes}</span>;
}
